import { Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Box, Flex } from "@chakra-ui/react";
import { BodyText2 } from "src/atoms/typography";

export default function AudioLoader({ onStop, forceDarkMode }) {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center">
      <Flex
        onClick={onStop}
        pos="relative"
        justifyContent="center"
        align="center"
      >
        <Box
          bg="primary"
          width="6px"
          height="6px"
          transform="translate(-50%, -50%)"
          top="50%"
          left="50%"
          position="absolute"
          border-radius="1.5px"
        />
        <Spinner size="sm" borderWidth="2px" />
      </Flex>
      <BodyText2 ml="6px" color={forceDarkMode ? "white70" : "mediumEmphasis"}>
        {t("loading")}
      </BodyText2>
    </Flex>
  );
}
